/* Extend react-bootstrap with an <XLCol> column tag, allowing styling for > 1600px browsers */

import * as PropTypes from 'prop-types';
import * as React from 'react';
import * as _ from 'lodash';
import { Col } from 'react-bootstrap';

import * as AppUtilities from '../apputilities';

import './bootstrapcolxl.css';

export const validValueRange: Array<number> = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];

export const getXlColClass = (val: number, modifier: string = '') => `col-xl-${modifier ? modifier + '-' : ''}${val}`;
export const getXlOffsetClass = (val: number) => getXlColClass(val, 'offset');
export const getXlPushClass = (val: number) => getXlColClass(val, 'push');
export const getXlPullClass = (val: number) => getXlColClass(val, 'pull');
export const getXlHiddenClass = (hidden: boolean = false) => `hidden-xl`;

export class BootstrapColXl extends React.Component<any, any> {
    public static propTypes = {
        xl: PropTypes.oneOf(validValueRange),
        xlHidden: PropTypes.bool,
        xlOffset: PropTypes.oneOf(validValueRange),
        xlPull: PropTypes.oneOf(validValueRange),
        xlPush: PropTypes.oneOf(validValueRange),
    };

    public constructor(props: any, context: any) {
        super(props, context);
    }

    public isXlValueValid(xl: any) {
        if (!AppUtilities.isNumeric(xl)) { return false; }

        if (!_.includes(validValueRange, xl)) { return false; }

        return true;
    }

    public addClass(addClass: string, existingClassNames?: string): string {
        let result = existingClassNames ? existingClassNames : '';

        if (!addClass) { return result; }

        result = `${result} ${addClass}`.trim();

        return result;
    }

    public render() {
        const { xl, xlHidden, xlOffset, xlPull, xlPush, className, ...props } = this.props;

        let classNames = className;

        if (this.isXlValueValid(xl)) {
            const c = getXlColClass(xl);
            classNames = this.addClass(c, classNames);
        }

        if (xlHidden) {
            const c = getXlHiddenClass(xlHidden);
            classNames = this.addClass(c, classNames);
        }

        if (this.isXlValueValid(xlOffset)) {
            const c = getXlOffsetClass(xlOffset);
            classNames = this.addClass(c, classNames);
        }

        if (this.isXlValueValid(xlPush)) {
            const c = getXlPushClass(xlPush);
            classNames = this.addClass(c, classNames);
        }

        if (this.isXlValueValid(xlPull)) {
            const c = getXlPushClass(xlPull);
            classNames = this.addClass(c, classNames);
        }

        return (
            <Col className={classNames} {...props} />
        );
    }
}



// WEBPACK FOOTER //
// ./src/common/bootstrap/bootstrapcolxl.tsx